module.exports = __webpack_public_path__ + "static/img/jp7.bf30e859.png";